import $ from 'jquery';
import Cookies from 'js-cookie';
import { delay } from 'lodash';
export class FeaturedPopup {
    constructor() {
        this.selector = '.featured-popup';
        if ($(this.selector).length === 0)
            return;
        $(this.selector).each((_, element) => {
            const { cookieName } = element.dataset;
            const $btnMinimize = $(element).find('.btn-minimize');
            const $btnClose = $(element).find('.btn-close');
            const $btnCta = $(element).find('.btn');
            $btnMinimize.on('click', () => {
                $(element).addClass('is-minimize');
                Cookies.set(cookieName, 'true', { expires: 365 });
            });
            $btnClose.on('click', () => {
                const { innerWidth } = window;
                $(element).addClass('d-none');
                Cookies.set(`${cookieName}_CLOSED`, 'true');
                if (innerWidth <= 767) {
                    Cookies.set(cookieName, 'true');
                }
            });
            $btnCta.on('click', () => {
                Cookies.set(cookieName, 'true');
            });
            this.detectCookie(element, cookieName);
            this.beforeunload(cookieName);
        });
    }
    beforeunload(cookieName) {
        let cookieClosedFeaturedModal = Cookies.get(`${cookieName}_CLOSED`);
        $(window).on("beforeunload", function () {
            if (typeof cookieClosedFeaturedModal !== 'undefined' || cookieClosedFeaturedModal) {
                Cookies.remove(`${cookieName}_CLOSED`);
            }
        });
    }
    detectCookie(element, cookieName) {
        let cookieFeaturedModal = Cookies.get(cookieName);
        let cookieClosedFeaturedModal = Cookies.get(`${cookieName}_CLOSED`);
        if (typeof cookieClosedFeaturedModal === 'undefined' ||
            cookieClosedFeaturedModal === 'false') {
            delay(() => {
                $(element).removeClass('d-none');
            }, 3000);
        }
        if (typeof cookieFeaturedModal === 'undefined')
            return;
        try {
            cookieFeaturedModal = JSON.parse(cookieFeaturedModal);
            $(element).addClass('is-minimize');
        }
        catch (err) {
            // console.log(err);
        }
    }
}
